import { constantsData, formFieldNamesData } from "@/data";
import { optionsData } from "@/data/options";
import { AsyncDataKeyEnum, FieldTypeEnum } from "@/enums";

const {
    dataAction,
    date,
    dateFormat,
    hasTime,
    time,
    timeFormat,
    timeZone,
} = constantsData.forms.dataSources.transform.dateTime;

const {
    dataAction: dataActionFieldName,
    dateField: dateFieldName,
    dateFormat: dateFormatFieldName,
    hasTimeComponent: hasTimeComponentFieldName,
    timeField: timeFieldName,
    timeFormat: timeFormatFieldName,
    timeZone: timeZoneFieldName,
} = formFieldNamesData;
export const transformOfflineDataSourceDateTimeFieldFormData = [
    {
        description: dataAction.description,
        hasOptionFormat: true,
        label: dataAction.label,
        name: dataActionFieldName,
        options: optionsData.dataSource.transform.dateTime.dataActions,
        type: FieldTypeEnum.SELECT,
    },
    {
        description: date.description,
        label: date.label,
        name: dateFieldName,
        options: [],
        type: FieldTypeEnum.SELECT,
    },
    {
        description: dateFormat.description,
        label: dateFormat.label,
        name: dateFormatFieldName,
        options: optionsData.dataSource.transform.dateTime.dateFormats,
        type: FieldTypeEnum.SELECT,
    },
    {
        description: "",
        label: hasTime.label,
        name: hasTimeComponentFieldName,
        type: FieldTypeEnum.SWITCH,
    },
    {
        description: time.description,
        label: time.label,
        name: timeFieldName,
        options: [],
        type: FieldTypeEnum.SELECT,
    },
    {
        description: timeFormat.description,
        label: timeFormat.label,
        name: timeFormatFieldName,
        options: optionsData.dataSource.transform.dateTime.timeFormat,
        type: FieldTypeEnum.SELECT,
    },
    {
        dataKey: AsyncDataKeyEnum.TIME_ZONES,
        description: timeZone.description,
        isAsync: true,
        label: timeZone.label,
        name: timeZoneFieldName,
        type: FieldTypeEnum.SELECT,
    },
];
